"use client";

import { useStore } from "@tanstack/react-store";
import type { TUseFiltersStore } from "./filters.config";
import { filtersDispatch, filtersStore } from "./filters.store";

export const useFiltersStore = (): TUseFiltersStore => {
  const filters = useStore(filtersStore, (state) => state.filters);

  return {
    filters,
    replaceFilterGroup: filtersDispatch.replaceFilterGroup,
    updateFilters: filtersDispatch.updateFilters,
  };
};
